var _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourceDepolyment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 2606",
    style: {
      enableBackground: "new 0 0 3000 2606"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3000,
    height: 2606
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 738.255,
    ry: 67.042
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.0385
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 723.291,
    ry: 65.683
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.0769
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 708.328,
    ry: 64.324
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1154
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 693.364,
    ry: 62.965
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1538
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 678.401,
    ry: 61.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1923
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 663.437,
    ry: 60.248
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.2308
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 648.474,
    ry: 58.889
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.2692
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 633.51,
    ry: 57.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3077
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 618.546,
    ry: 56.171
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3462
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 603.583,
    ry: 54.812
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3846
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 588.619,
    ry: 53.453
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4231
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 573.656,
    ry: 52.095
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4615
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 558.692,
    ry: 50.736
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 543.729,
    ry: 49.377
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5385
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 528.765,
    ry: 48.018
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5769
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 513.801,
    ry: 46.659
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6154
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 498.838,
    ry: 45.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6538
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 483.874,
    ry: 43.941
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6923
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 468.911,
    ry: 42.583
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.7308
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 453.947,
    ry: 41.224
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.7692
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 438.984,
    ry: 39.865
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8077
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 424.02,
    ry: 38.506
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8462
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 409.057,
    ry: 37.147
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8846
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 394.093,
    ry: 35.788
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.9231
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 379.129,
    ry: 34.429
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.9615
    },
    cx: 819.355,
    cy: 2142.045,
    rx: 364.166,
    ry: 33.07
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 819.355,
    cy: 2142.045,
    rx: 349.202,
    ry: 31.712
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 557.545,
    ry: 115.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.0385
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 546.245,
    ry: 113.589
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.0769
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 534.944,
    ry: 111.239
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1154
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 523.643,
    ry: 108.889
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1538
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 512.342,
    ry: 106.539
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1923
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 501.041,
    ry: 104.189
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.2308
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 489.741,
    ry: 101.839
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.2692
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 478.44,
    ry: 99.489
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3077
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 467.139,
    ry: 97.139
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3462
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 455.838,
    ry: 94.789
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3846
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 444.537,
    ry: 92.439
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4231
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 433.237,
    ry: 90.089
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4615
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 421.936,
    ry: 87.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 410.635,
    ry: 85.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5385
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 399.334,
    ry: 83.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5769
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 388.033,
    ry: 80.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6154
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 376.733,
    ry: 78.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6538
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 365.432,
    ry: 75.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6923
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 354.131,
    ry: 73.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.7308
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 342.83,
    ry: 71.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.7692
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 331.529,
    ry: 68.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8077
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 320.229,
    ry: 66.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8462
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 308.928,
    ry: 64.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8846
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 297.627,
    ry: 61.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.9231
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 286.326,
    ry: 59.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.9615
    },
    cx: 1564.355,
    cy: 1734.942,
    rx: 275.026,
    ry: 57.19
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1564.355,
    cy: 1734.942,
    rx: 263.725,
    ry: 54.84
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.17
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 557.545,
    ry: 115.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.0385
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 546.245,
    ry: 113.589
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.0769
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 534.944,
    ry: 111.239
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1154
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 523.643,
    ry: 108.889
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1538
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 512.342,
    ry: 106.539
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1923
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 501.041,
    ry: 104.189
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.2308
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 489.741,
    ry: 101.839
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.2692
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 478.44,
    ry: 99.489
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3077
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 467.139,
    ry: 97.139
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3462
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 455.838,
    ry: 94.789
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3846
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 444.537,
    ry: 92.439
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4231
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 433.237,
    ry: 90.089
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.4615
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 421.936,
    ry: 87.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 410.635,
    ry: 85.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5385
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 399.334,
    ry: 83.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.5769
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 388.033,
    ry: 80.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6154
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 376.733,
    ry: 78.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6538
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 365.432,
    ry: 75.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6923
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 354.131,
    ry: 73.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.7308
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 342.83,
    ry: 71.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.7692
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 331.529,
    ry: 68.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8077
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 320.229,
    ry: 66.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8462
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 308.928,
    ry: 64.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.8846
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 297.627,
    ry: 61.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.9231
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 286.326,
    ry: 59.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.9615
    },
    cx: 2361.355,
    cy: 1999.942,
    rx: 275.026,
    ry: 57.19
  }), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2361.355,
    cy: 1999.942,
    rx: 263.725,
    ry: 54.84
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1564.8507,
    y1: 1706.4385,
    x2: 1564.8507,
    y2: 471.882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M1896.401,596.998v1106.029c0,21.321-17.307,38.628-38.628,38.628h-585.844 c-21.321,0-38.628-17.307-38.628-38.628V596.998c0-21.321,17.307-38.628,38.628-38.628h585.844 C1879.094,558.371,1896.401,575.677,1896.401,596.998z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6"
    },
    d: "M1870.366,603.765v1092.504c0,12.887-10.447,23.334-23.334,23.334h-564.369 c-12.887,0-23.335-10.448-23.335-23.335V603.765c0-12.888,10.447-23.335,23.335-23.335h178.705 c4.311,0,8.384,1.971,11.059,5.352l12.315,15.564c2.675,3.38,6.749,5.352,11.059,5.352h138.091 c4.31,0,8.384-1.971,11.059-5.352l12.315-15.564c2.675-3.38,6.749-5.352,11.059-5.352h178.705 C1859.919,580.43,1870.366,590.878,1870.366,603.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1847.924,680.669c0,10.558-3.571,20.029-9.181,26.861c-5.611,6.987-13.389,11.18-21.932,11.18 h-504.438c-17.215,0-31.241-17.08-31.241-38.041c0-10.403,3.443-19.875,9.18-26.707c5.611-6.832,13.389-11.179,22.06-11.179 h504.438C1833.897,642.784,1847.924,659.863,1847.924,680.669z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039127773928738097900000011148727321069922450_",
    gradientUnits: "userSpaceOnUse",
    x1: 1720.0291,
    y1: 680.7472,
    x2: 1847.924,
    y2: 680.7472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF871A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039127773928738097900000011148727321069922450_)"
    },
    d: "M1847.924,680.669 c0,10.558-3.571,20.029-9.181,26.861c-5.611,6.987-13.389,11.18-21.932,11.18h-96.782v-75.927h96.782 C1833.897,642.784,1847.924,659.863,1847.924,680.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6"
    },
    d: "M1793.77,691.171l-0.529,0.495l-11.568-12.366h0c0.757-0.708,0.797-1.895,0.089-2.652 l-0.9-0.962c4.063-6.614,3.484-15.324-2.542-21.015c-6.093-5.754-15.697-6.134-22.213-0.858 c-7.716,6.248-8.401,17.597-1.741,24.717c5.318,5.685,13.525,6.597,20.099,3.14l0.9,0.962 c0.708,0.757,1.895,0.796,2.652,0.088l0,0l11.568,12.366l-0.529,0.495c-0.348,0.326-0.366,0.872-0.041,1.22l13.347,14.268 c0.398,0.426,1.066,0.448,1.492,0.049l4.433-4.146c0.426-0.398,0.448-1.066,0.05-1.492l-13.347-14.268 C1794.664,690.863,1794.118,690.845,1793.77,691.171z M1757.452,677.613c-6.739-5.91-6.384-16.42,0.737-21.867 c5.268-4.03,12.813-3.778,17.798,0.596c6.735,5.91,6.382,16.414-0.735,21.862 C1769.984,682.236,1762.438,681.986,1757.452,677.613z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072255503475591411150000000651790692717671075_",
    gradientUnits: "userSpaceOnUse",
    x1: 1564.8472,
    y1: 1158.3025,
    x2: 1564.8472,
    y2: 799.5225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF871A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072255503475591411150000000651790692717671075_)"
    },
    d: "M1788.677,1168.465h-447.659 c-1.21,0-2.191-0.981-2.191-2.191V872.725c0-1.21,0.981-2.191,2.191-2.191h447.659c1.21,0,2.191,0.981,2.191,2.191v293.549 C1790.867,1167.484,1789.887,1168.465,1788.677,1168.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1554.512,1370.095h-213.494c-1.21,0-2.191-0.981-2.191-2.191v-165.979 c0-1.21,0.981-2.191,2.191-2.191h213.494c1.21,0,2.191,0.981,2.191,2.191v165.979 C1556.703,1369.114,1555.722,1370.095,1554.512,1370.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1788.393,1370.095h-213.495c-1.21,0-2.19-0.981-2.19-2.191v-165.979 c0-1.21,0.981-2.191,2.19-2.191h213.495c1.21,0,2.191,0.981,2.191,2.191v165.979 C1790.583,1369.114,1789.602,1370.095,1788.393,1370.095z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9936 -0.1132 0.1132 0.9936 -155.0874 163.7091)",
    style: {
      fill: "#C4C4C4"
    },
    cx: 1364.613,
    cy: 1448.061,
    rx: 25.786,
    ry: 25.786
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1684.841,1513.688h-345.42c-0.327,0-0.594-0.268-0.594-0.594v-13.971 c0-0.327,0.267-0.594,0.594-0.594h345.42c0.327,0,0.594,0.268,0.594,0.594v13.971 C1685.435,1513.421,1685.168,1513.688,1684.841,1513.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1789.989,1548.796h-450.567c-0.327,0-0.594-0.267-0.594-0.594v-13.971 c0-0.327,0.267-0.594,0.594-0.594h450.567c0.327,0,0.594,0.267,0.594,0.594v13.971 C1790.583,1548.528,1790.316,1548.796,1789.989,1548.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1789.989,1583.903h-450.567c-0.327,0-0.594-0.268-0.594-0.594v-13.971 c0-0.327,0.267-0.594,0.594-0.594h450.567c0.327,0,0.594,0.268,0.594,0.594v13.971 C1790.583,1583.636,1790.316,1583.903,1789.989,1583.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1635.375,1619.011h-295.954c-0.327,0-0.594-0.267-0.594-0.594v-13.971 c0-0.327,0.267-0.594,0.594-0.594h295.954c0.327,0,0.594,0.268,0.594,0.594v13.971 C1635.969,1618.744,1635.702,1619.011,1635.375,1619.011z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9996 -0.0294 0.0294 0.9996 -22.7451 40.4643)",
    style: {
      fill: "#D8D8D8"
    },
    cx: 1363.34,
    cy: 792.963,
    rx: 24.514,
    ry: 24.514
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1746.73,805.944h-329.66c-0.359,0-0.652-0.294-0.652-0.652v-15.331 c0-0.359,0.294-0.652,0.652-0.652h329.66c0.359,0,0.652,0.293,0.652,0.652v15.331 C1747.382,805.65,1747.089,805.944,1746.73,805.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1663.728,1037.166c1.055-5.669,1.582-11.602,1.582-17.667c0-6.064-0.527-11.997-1.582-17.666 h-24.391c-1.845-8.042-5.009-15.689-9.36-22.545l17.271-17.139c-6.724-9.756-15.294-18.326-25.05-25.05l-17.271,17.272 c-6.855-4.351-14.37-7.515-22.413-9.361v-24.391c-5.669-1.054-11.601-1.582-17.666-1.582c-6.065,0-11.998,0.528-17.667,1.582 v24.391c-8.042,1.846-15.557,5.01-22.412,9.361l-17.272-17.272c-9.756,6.724-18.325,15.294-25.049,25.05l17.271,17.139 c-4.351,6.856-7.515,14.503-9.361,22.545h-24.39c-1.055,5.669-1.582,11.602-1.582,17.666c0,6.065,0.527,11.998,1.582,17.667 h24.39c1.846,8.042,5.01,15.557,9.361,22.413l-17.271,17.271c6.724,9.756,15.161,18.194,24.918,25.049l17.271-17.271 c6.855,4.351,14.502,7.515,22.544,9.361v24.39c5.669,1.055,11.602,1.583,17.667,1.583c6.065,0,11.997-0.528,17.666-1.583 v-24.39c8.043-1.846,15.689-5.01,22.545-9.361l17.271,17.271c9.756-6.855,18.194-15.293,24.918-25.049l-17.271-17.271 c4.351-6.856,7.515-14.371,9.36-22.413H1663.728z M1564.847,1063.545c-24.326,0-44.046-19.72-44.046-44.046 c0-24.326,19.72-44.046,44.046-44.046s44.046,19.72,44.046,44.046C1608.893,1043.825,1589.173,1063.545,1564.847,1063.545z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1309.972,
    y: 1387.063,
    style: {
      fill: "#D8D8D8"
    },
    width: 509.113,
    height: 2.641
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3B3",
      strokeWidth: 0.3,
      strokeMiterlimit: 10
    },
    d: "M1845.638,1692.488h-562.219 c-1.263,0-2.286-1.024-2.286-2.286V755.182c0-1.263,1.024-2.286,2.286-2.286h562.219c1.263,0,2.286,1.024,2.286,2.286v935.019 C1847.924,1691.464,1846.9,1692.488,1845.638,1692.488z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6",
      stroke: "#CCCCCC",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M1262.785,657.789v388.161 c0,12.766-10.356,23.122-23.121,23.122H909.577c-12.765,0-23.001-10.356-23.001-23.122V657.789 c0-12.765,10.236-23.122,23.001-23.122h330.087C1252.429,634.667,1262.785,645.024,1262.785,657.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1168.715,963.741H921.997c-0.247,0-0.45-0.202-0.45-0.45v-9.931c0-0.247,0.202-0.45,0.45-0.45 h246.718c0.247,0,0.45,0.202,0.45,0.45v9.931C1169.165,963.539,1168.962,963.741,1168.715,963.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1243.833,992.729H921.997c-0.247,0-0.45-0.202-0.45-0.45v-9.931c0-0.247,0.202-0.45,0.45-0.45 h321.836c0.247,0,0.45,0.202,0.45,0.45v9.931C1244.282,992.526,1244.08,992.729,1243.833,992.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1133.376,1017.81h-211.38c-0.247,0-0.45-0.202-0.45-0.45v-9.931c0-0.247,0.202-0.45,0.45-0.45 h211.38c0.247,0,0.45,0.202,0.45,0.45v9.931C1133.826,1017.607,1133.624,1017.81,1133.376,1017.81z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116220615385548235170000010450857389801798796_",
    gradientUnits: "userSpaceOnUse",
    x1: 886.5763,
    y1: 656.0429,
    x2: 1262.7852,
    y2: 656.0429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38ACA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F637A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116220615385548235170000010450857389801798796_)"
    },
    d: "M1262.785,657.789v19.629H886.576 v-19.629c0-12.765,10.236-23.122,23.001-23.122h330.087C1252.429,634.667,1262.785,645.024,1262.785,657.789z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB7B1"
    },
    d: "M1056.997,836.608l0,14.979c0,0,3.201,4.892,18.216,4.719 c15.015-0.173,17.091-3.979,17.091-3.979l0-19.203L1056.997,836.608z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057118299279602838440000011073880605187042735_",
    gradientUnits: "userSpaceOnUse",
    x1: 958.5179,
    y1: 808.9318,
    x2: 1022.6413,
    y2: 808.9318,
    gradientTransform: "matrix(-1 0 0 1 2065.7925 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057118299279602838440000011073880605187042735_)"
    },
    d: "M1106.526,772.451 c0,0,8.312,67.876-30.475,72.962h-1.676c-38.787-5.086-30.476-72.962-30.476-72.962H1106.526z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036965388976800053380000014958509021934577041_",
    gradientUnits: "userSpaceOnUse",
    x1: 1037.6917,
    y1: 780.2521,
    x2: 1116.4376,
    y2: 780.2521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036965388976800053380000014958509021934577041_)"
    },
    d: "M1052.162,782.469 c0,0-0.657,26.393-2.63,27.764s-1.419-12.145-3.946-13.882s0.441,13.392-0.766,13.98c-1.207,0.588-4.18-8.931-6.389-24.356 c-2.209-15.425,1.237-20.644,1.237-20.644s4.603-20.909,42.908-18.681c38.305,2.228,33.688,34.71,33.688,34.71 s-4.918,19.105-7.549,22.19s-4.256,10.471-4.256,10.471s3.763-15.956,2.119-20.24c-1.644-4.285-8.549,8.569-8.549,8.569 l-0.329-13.368c0,0-9.659,6.684-24.064,4.627C1059.231,791.552,1052.162,782.469,1052.162,782.469z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005227637525514068480000018021107232869263018_",
    gradientUnits: "userSpaceOnUse",
    x1: 1005.7131,
    y1: 878.0508,
    x2: 1143.6478,
    y2: 878.0508
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38ACA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F637A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005227637525514068480000018021107232869263018_)"
    },
    d: "M1143.648,876.174 c-16.682,19.496-41.391,31.799-68.916,31.799c-27.628,0-52.337-12.302-69.019-31.799c2.085-4.483,4.066-8.757,5.943-12.094 c2.19-3.649,4.171-6.464,6.047-7.819c10.321-7.611,37.325-8.133,39.306-8.133c0.104,0,0.104,0,0.104,0 s-1.043,2.92,6.255,5.839c3.441,1.355,19.288,1.355,22.624,0c5.839-2.293,6.36-4.692,6.36-5.525c0-0.209,0-0.313,0-0.313 s28.671,0.209,39.41,8.133c1.877,1.355,3.858,4.17,5.943,7.819C1139.686,867.417,1141.667,871.691,1143.648,876.174z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156580673050811792030000011286139790205829310_",
    gradientUnits: "userSpaceOnUse",
    x1: 984.1321,
    y1: 817.4766,
    x2: 1165.2295,
    y2: 817.4766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38ACA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F637A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156580673050811792030000011286139790205829310_)"
    },
    d: "M1074.732,726.98 c-50.044,0-90.6,40.452-90.6,90.496c0,22.416,8.132,42.955,21.581,58.698c16.682,19.496,41.391,31.799,69.019,31.799 c27.525,0,52.234-12.302,68.916-31.799c13.449-15.743,21.582-36.282,21.582-58.698 C1165.229,767.432,1124.673,726.98,1074.732,726.98z M1137.705,864.081c-14.179,19.288-37.116,31.799-62.973,31.799 c-25.856,0-48.793-12.511-63.076-31.799c-9.696-13.032-15.43-29.192-15.43-46.604c0-43.371,35.135-78.402,78.507-78.402 c43.268,0,78.403,35.031,78.403,78.402C1153.135,834.888,1147.401,851.048,1137.705,864.081z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6"
    },
    d: "M2382.855,583.096v194.598c0,9.457-7.672,17.129-17.128,17.129h-417.684 c-9.456,0-17.039-7.672-17.039-17.129V583.096c0-9.456,7.583-17.129,17.039-17.129h417.684 C2375.183,565.967,2382.855,573.639,2382.855,583.096z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2304.884,636.328H2122.35c-0.247,0-0.45-0.202-0.45-0.45v-7.124c0-0.247,0.202-0.45,0.45-0.45 h182.534c0.247,0,0.449,0.202,0.449,0.45v7.124C2305.333,636.126,2305.131,636.328,2304.884,636.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2304.884,696.143H2122.35c-0.247,0-0.45-0.202-0.45-0.45v-7.124c0-0.247,0.202-0.45,0.45-0.45 h182.534c0.247,0,0.449,0.202,0.449,0.45v7.124C2305.333,695.941,2305.131,696.143,2304.884,696.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2360.53,657.802h-238.18c-0.247,0-0.45-0.202-0.45-0.45v-7.124c0-0.247,0.202-0.45,0.45-0.45 h238.18c0.247,0,0.45,0.202,0.45,0.45v7.124C2360.98,657.6,2360.778,657.802,2360.53,657.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2278.705,676.382H2122.35c-0.247,0-0.45-0.202-0.45-0.45v-7.124c0-0.247,0.202-0.45,0.45-0.45 h156.355c0.247,0,0.45,0.202,0.45,0.45v7.124C2279.155,676.18,2278.952,676.382,2278.705,676.382z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M2382.855,583.096v14.541h-451.851v-14.541c0-9.456,7.583-17.129,17.039-17.129h417.684 C2375.183,565.967,2382.855,573.639,2382.855,583.096z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M2013.555,690.554v11.096c0,0,2.371,3.624,13.494,3.496 c11.123-0.128,12.661-2.948,12.661-2.948l0-14.225L2013.555,690.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M2050.719,643.027c0,0,6.393,50.282-23.442,54.05h-1.289 c-29.835-3.768-23.442-54.05-23.442-54.05L2050.719,643.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M2077.745,719.865c-12.358,14.443-30.662,23.556-51.052,23.556 c-20.467,0-38.771-9.114-51.129-23.556c1.545-3.321,3.012-6.487,4.402-8.959c1.622-2.703,3.09-4.788,4.48-5.792 c7.646-5.638,27.65-6.024,29.117-6.024c0.077,0,0.077,0,0.077,0s-0.773,2.163,4.634,4.325c2.549,1.004,14.288,1.004,16.76,0 c4.325-1.699,4.711-3.476,4.711-4.093c0-0.155,0-0.232,0-0.232s21.24,0.155,29.195,6.024c1.39,1.004,2.857,3.089,4.402,5.792 C2074.811,713.377,2076.278,716.544,2077.745,719.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E9E9E"
    },
    d: "M2054.102,637.956c0.008-0.008,0.06-0.019,0.058-0.027c-0.154-0.57-1.913-17.571-23.03-18.598 c-21.118-1.026-25.018,11.416-25.018,11.416s-9.553-0.577-9.376,17.49c0.177,18.068,6.501,22.851,6.501,22.851 s-1.74-10.267,0.567-10.356c2.308-0.089,0.698,10.095,2.123,9.32c1.426-0.775,4.251-10.34,2.749-19.604 c0,0,14.065,3.65,24.148,1.704c10.083-1.946,10.875,4.431,11.629,9.999c0.754,5.569,0.931,12.533,2.346,7.901 c1.415-4.632,0.935-9.673,3.361-9.045c2.426,0.628-3.085,11.22-0.658,10.558 C2051.222,671.097,2057.883,651.333,2054.102,637.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6"
    },
    d: "M2013.641,699.089l11.428,5.058l-9.047,6.312l-7.716-11.37 C2008.307,699.089,2010.369,696.028,2013.641,699.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6"
    },
    d: "M2036.498,699.089l-11.428,5.058l9.047,6.312l7.716-11.37 C2041.833,699.089,2039.77,696.028,2036.498,699.089z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9E9E9E"
    },
    points: "2029.012,708.975 2030.537,707.962 2025.07,704.147 2019.602,707.962  2021.127,708.975 2017.185,742.753 2025.07,743.387 2032.954,742.753  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2026.693,609.343c-37.072,0-67.116,29.967-67.116,67.039c0,16.605,6.024,31.82,15.987,43.483 c12.358,14.443,30.662,23.556,51.129,23.556c20.39,0,38.694-9.114,51.052-23.556c9.963-11.662,15.988-26.877,15.988-43.483 C2093.733,639.31,2063.689,609.343,2026.693,609.343z M2073.343,710.906c-10.504,14.288-27.495,23.556-46.65,23.556 c-19.154,0-36.146-9.268-46.727-23.556c-7.183-9.654-11.431-21.625-11.431-34.524c0-32.129,26.028-58.08,58.157-58.08 c32.052,0,58.08,25.951,58.08,58.08C2084.773,689.28,2080.526,701.251,2073.343,710.906z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6"
    },
    d: "M2382.855,843.187v194.598c0,9.457-7.672,17.129-17.128,17.129h-417.684 c-9.456,0-17.039-7.672-17.039-17.129V843.187c0-9.456,7.583-17.129,17.039-17.129h417.684 C2375.183,826.058,2382.855,833.731,2382.855,843.187z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2126.924,1011.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2143.181,1011.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2168.244,1011.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2184.501,1011.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2209.563,1011.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2225.821,1011.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2250.883,1011.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2267.14,1011.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2292.203,1011.978"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2308.46,1011.978"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2304.884,896.42H2122.35c-0.247,0-0.45-0.202-0.45-0.45v-7.124c0-0.247,0.202-0.45,0.45-0.45 h182.534c0.247,0,0.449,0.202,0.449,0.45v7.124C2305.333,896.217,2305.131,896.42,2304.884,896.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2304.884,956.235H2122.35c-0.247,0-0.45-0.202-0.45-0.45v-7.124c0-0.247,0.202-0.45,0.45-0.45 h182.534c0.247,0,0.449,0.202,0.449,0.45v7.124C2305.333,956.032,2305.131,956.235,2304.884,956.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2360.53,917.894h-238.18c-0.247,0-0.45-0.202-0.45-0.45v-7.124c0-0.247,0.202-0.45,0.45-0.45 h238.18c0.247,0,0.45,0.202,0.45,0.45v7.124C2360.98,917.691,2360.778,917.894,2360.53,917.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2278.705,936.473H2122.35c-0.247,0-0.45-0.202-0.45-0.45V928.9c0-0.247,0.202-0.45,0.45-0.45 h156.355c0.247,0,0.45,0.202,0.45,0.45v7.124C2279.155,936.271,2278.952,936.473,2278.705,936.473z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M2382.855,843.187v14.541h-451.851v-14.541c0-9.456,7.583-17.129,17.039-17.129h417.684 C2375.183,826.058,2382.855,833.731,2382.855,843.187z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M2013.555,950.646v11.096c0,0,2.371,3.624,13.494,3.496 c11.123-0.128,12.661-2.948,12.661-2.948l0-14.225L2013.555,950.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M2050.719,903.118c0,0,6.393,50.282-23.442,54.05h-1.289 c-29.835-3.768-23.442-54.05-23.442-54.05L2050.719,903.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M2077.745,979.956c-12.358,14.443-30.662,23.556-51.052,23.556 c-20.467,0-38.771-9.114-51.129-23.556c1.545-3.321,3.012-6.487,4.402-8.959c1.622-2.703,3.09-4.788,4.48-5.792 c7.646-5.638,27.65-6.025,29.117-6.025c0.077,0,0.077,0,0.077,0s-0.773,2.163,4.634,4.325c2.549,1.004,14.288,1.004,16.76,0 c4.325-1.699,4.711-3.476,4.711-4.093c0-0.155,0-0.232,0-0.232s21.24,0.155,29.195,6.025c1.39,1.004,2.857,3.089,4.402,5.792 C2074.811,973.469,2076.278,976.635,2077.745,979.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9E9E9E"
    },
    d: "M2054.102,898.047c0.008-0.008,0.06-0.019,0.058-0.027c-0.154-0.57-1.913-17.571-23.03-18.598 c-21.118-1.026-25.018,11.416-25.018,11.416s-9.553-0.577-9.376,17.49c0.177,18.068,6.501,22.851,6.501,22.851 s-1.74-10.267,0.567-10.356c2.308-0.089,0.698,10.095,2.123,9.32c1.426-0.775,4.251-10.339,2.749-19.603 c0,0,14.065,3.65,24.148,1.704c10.083-1.946,10.875,4.431,11.629,9.999c0.754,5.569,0.931,12.533,2.346,7.901 s0.935-9.673,3.361-9.045c2.426,0.628-3.085,11.22-0.658,10.558C2051.222,931.188,2057.883,911.424,2054.102,898.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6"
    },
    d: "M2013.641,959.18l11.428,5.058l-9.047,6.312l-7.716-11.37 C2008.307,959.18,2010.369,956.119,2013.641,959.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6"
    },
    d: "M2036.498,959.18l-11.428,5.058l9.047,6.312l7.716-11.37 C2041.833,959.18,2039.77,956.119,2036.498,959.18z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9E9E9E"
    },
    points: "2029.012,969.067 2030.537,968.053 2025.07,964.238 2019.602,968.053  2021.127,969.067 2017.185,1002.844 2025.07,1003.478 2032.954,1002.844  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M2026.693,869.434c-37.072,0-67.116,29.967-67.116,67.039c0,16.605,6.024,31.82,15.987,43.483 c12.358,14.443,30.662,23.556,51.129,23.556c20.39,0,38.694-9.114,51.052-23.556c9.963-11.662,15.988-26.877,15.988-43.483 C2093.733,899.401,2063.689,869.434,2026.693,869.434z M2073.343,970.997c-10.504,14.288-27.495,23.556-46.65,23.556 c-19.154,0-36.146-9.268-46.727-23.556c-7.183-9.654-11.431-21.625-11.431-34.524c0-32.129,26.028-58.08,58.157-58.08 c32.052,0,58.08,25.951,58.08,58.08C2084.773,949.372,2080.526,961.343,2073.343,970.997z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6",
      stroke: "#CCCCCC",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M1262.785,1129.958v388.161 c0,12.766-10.356,23.122-23.121,23.122H909.577c-12.765,0-23.001-10.356-23.001-23.122v-388.161 c0-12.765,10.236-23.122,23.001-23.122h330.087C1252.429,1106.836,1262.785,1117.193,1262.785,1129.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1168.715,1435.91H921.997c-0.247,0-0.45-0.202-0.45-0.45v-9.931c0-0.247,0.202-0.45,0.45-0.45 h246.718c0.247,0,0.45,0.202,0.45,0.45v9.931C1169.165,1435.708,1168.962,1435.91,1168.715,1435.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1243.833,1464.898H921.997c-0.247,0-0.45-0.202-0.45-0.45v-9.931c0-0.247,0.202-0.45,0.45-0.45 h321.836c0.247,0,0.45,0.202,0.45,0.45v9.931C1244.282,1464.695,1244.08,1464.898,1243.833,1464.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1133.376,1489.979h-211.38c-0.247,0-0.45-0.202-0.45-0.45v-9.931c0-0.247,0.202-0.45,0.45-0.45 h211.38c0.247,0,0.45,0.202,0.45,0.45v9.931C1133.826,1489.776,1133.624,1489.979,1133.376,1489.979z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057854288143479768990000015012516703578283417_",
    gradientUnits: "userSpaceOnUse",
    x1: 886.5763,
    y1: 1128.2119,
    x2: 1262.7852,
    y2: 1128.2119
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38ACA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F637A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057854288143479768990000015012516703578283417_)"
    },
    d: "M1262.785,1129.958v19.629H886.576 v-19.629c0-12.765,10.236-23.122,23.001-23.122h330.087C1252.429,1106.836,1262.785,1117.193,1262.785,1129.958z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB7B1"
    },
    d: "M1056.981,1275.017v14.979c0,0,3.201,4.892,18.216,4.719 c15.015-0.173,17.091-3.979,17.091-3.979l0-19.203L1056.981,1275.017z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044875014283544860730000001792969265232673467_",
    gradientUnits: "userSpaceOnUse",
    x1: 958.5341,
    y1: 1247.3411,
    x2: 1022.6574,
    y2: 1247.3411,
    gradientTransform: "matrix(-1 0 0 1 2065.7925 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044875014283544860730000001792969265232673467_)"
    },
    d: "M1106.51,1210.86 c0,0,8.312,67.877-30.475,72.963h-1.676c-38.787-5.086-30.476-72.963-30.476-72.963L1106.51,1210.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108990532949435326980000006130118382671283122_",
    gradientUnits: "userSpaceOnUse",
    x1: 1005.697,
    y1: 1316.4601,
    x2: 1143.6317,
    y2: 1316.4601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF871A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108990532949435326980000006130118382671283122_)"
    },
    d: "M1143.632,1314.583 c-16.682,19.496-41.391,31.799-68.916,31.799c-27.628,0-52.337-12.302-69.019-31.799c2.085-4.483,4.066-8.757,5.943-12.094 c2.19-3.649,4.171-6.464,6.047-7.819c10.322-7.611,37.325-8.133,39.306-8.133c0.104,0,0.104,0,0.104,0 s-1.043,2.92,6.255,5.839c3.441,1.355,19.288,1.355,22.624,0c5.838-2.293,6.36-4.692,6.36-5.525c0-0.209,0-0.313,0-0.313 s28.671,0.209,39.41,8.133c1.877,1.355,3.858,4.17,5.943,7.819C1139.67,1305.826,1141.651,1310.1,1143.632,1314.583z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148650385958430897750000013837712394177266080_",
    gradientUnits: "userSpaceOnUse",
    x1: 1024.4359,
    y1: 1238.8241,
    x2: 1128.6923,
    y2: 1238.8241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148650385958430897750000013837712394177266080_)"
    },
    d: "M1043.135,1200.182 c0,0,9.073-11.911,22.945-14.508c13.872-2.597,25.123,0.528,41.178,9.479s15.095,53.999,13.242,68.028 c-1.853,14.029,8.191,29.675,8.191,29.675s-2.103-2.676-12.271-3.88c-10.167-1.204-24.086-2.439-24.086-2.439l-0.048-10.38 c0,0,0,0,5.515-6.912s3.904-20.359,3.639-24.065c-0.265-3.706-7.147-1.588-26.246-6.353 c-19.099-4.765-23.051-17.951-23.051-17.951s0.357,21.735-2.63,27.764c-2.987,6.029-2.374,10.738,0.698,16.206 c3.072,5.468,6.767,11.303,6.767,11.303l0.012,10.386c0,0-17.662,0.77-24.438,2.536c-6.775,1.766-8.119,2.225-8.119,2.225 s12.256-23.883,12.206-37.912c-0.051-14.029-3.757-25.676-2.963-36.793 C1034.473,1205.476,1043.135,1200.182,1043.135,1200.182z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166666612240462630140000014235662701999373218_",
    gradientUnits: "userSpaceOnUse",
    x1: 984.116,
    y1: 1255.8859,
    x2: 1165.2134,
    y2: 1255.8859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF871A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166666612240462630140000014235662701999373218_)"
    },
    d: "M1074.716,1165.389 c-50.044,0-90.6,40.452-90.6,90.496c0,22.416,8.132,42.955,21.581,58.698c16.682,19.496,41.391,31.799,69.019,31.799 c27.525,0,52.234-12.302,68.916-31.799c13.449-15.743,21.582-36.282,21.582-58.698 C1165.213,1205.842,1124.657,1165.389,1074.716,1165.389z M1137.689,1302.49c-14.179,19.288-37.116,31.799-62.973,31.799 c-25.856,0-48.793-12.511-63.076-31.799c-9.696-13.032-15.43-29.192-15.43-46.604c0-43.371,35.135-78.402,78.506-78.402 c43.268,0,78.403,35.031,78.403,78.402C1153.119,1273.297,1147.385,1289.458,1137.689,1302.49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M741.362,705.553c-43.165,0-78.216,34.948-78.216,78.216c0,14.562,3.953,28.291,10.921,39.941 c2.289,3.744,4.889,7.385,7.697,10.713c14.458,16.85,35.78,27.459,59.599,27.459c23.818,0,45.14-10.609,59.598-27.459 c2.808-3.328,5.408-6.969,7.697-10.713c6.865-11.649,10.921-25.379,10.921-39.941 C819.577,740.5,784.526,705.553,741.362,705.553z M801.584,814.764c-14.873-16.329-36.299-26.626-60.222-26.626 c-23.923,0-45.349,10.297-60.223,26.626c-4.888-9.361-7.593-19.867-7.593-30.996c0-37.443,30.371-67.711,67.815-67.711 c37.443,0,67.71,30.267,67.71,67.711C809.073,794.898,806.369,805.403,801.584,814.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M741.349,739.974c-12.638,0-22.883,10.246-22.883,22.884c0,12.638,10.245,22.884,22.884,22.884 c12.638,0,22.883-10.245,22.883-22.884C764.233,750.219,753.987,739.974,741.349,739.974z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M1217.261,514.638c0.738-3.966,1.107-8.117,1.107-12.36c0-4.243-0.369-8.393-1.107-12.36h-17.065 c-1.291-5.626-3.504-10.976-6.549-15.773l12.083-11.991c-4.704-6.825-10.7-12.821-17.526-17.525l-12.083,12.084 c-4.796-3.044-10.054-5.258-15.681-6.549v-17.065c-3.966-0.737-8.116-1.107-12.36-1.107c-4.243,0-8.394,0.369-12.36,1.107 v17.065c-5.627,1.292-10.884,3.505-15.68,6.549l-12.084-12.084c-6.826,4.704-12.821,10.7-17.525,17.525l12.083,11.991 c-3.044,4.797-5.258,10.147-6.549,15.773h-17.064c-0.738,3.966-1.107,8.117-1.107,12.36c0,4.243,0.369,8.394,1.107,12.36h17.064 c1.292,5.626,3.505,10.884,6.549,15.681l-12.083,12.083c4.704,6.826,10.607,12.729,17.433,17.525l12.083-12.083 c4.796,3.044,10.146,5.258,15.773,6.549v17.064c3.966,0.738,8.117,1.107,12.36,1.107c4.243,0,8.394-0.369,12.36-1.107v-17.064 c5.627-1.292,10.976-3.505,15.773-6.549l12.083,12.083c6.826-4.796,12.729-10.699,17.433-17.525l-12.083-12.083 c3.044-4.797,5.258-10.054,6.549-15.681H1217.261z M1148.082,533.093c-17.019,0-30.815-13.796-30.815-30.815 c0-17.019,13.796-30.815,30.815-30.815c17.019,0,30.815,13.796,30.815,30.815 C1178.897,519.297,1165.101,533.093,1148.082,533.093z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B3B3B3",
      strokeWidth: 0.3,
      strokeMiterlimit: 10
    },
    d: "M1820.397,530.348h-160.294 c-0.975,0-1.766-0.791-1.766-1.766V408.53c0-0.976,0.791-1.766,1.766-1.766h160.294c0.975,0,1.766,0.791,1.766,1.766v120.052 C1822.163,529.557,1821.372,530.348,1820.397,530.348z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1678.708,
    y: 489.646,
    style: {
      fill: "#D8D8D8"
    },
    width: 10.958,
    height: 30.677
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.133,
    y: 482.462,
    style: {
      fill: "#D8D8D8"
    },
    width: 10.958,
    height: 37.861
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1723.558,
    y: 462.852,
    style: {
      fill: "#D8D8D8"
    },
    width: 10.958,
    height: 57.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1745.983,
    y: 451.203,
    style: {
      fill: "#D8D8D8"
    },
    width: 10.958,
    height: 69.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1768.408,
    y: 426.351,
    style: {
      fill: "#D8D8D8"
    },
    width: 10.958,
    height: 93.972
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1790.833,
    y: 444.601,
    style: {
      fill: "#D8D8D8"
    },
    width: 10.958,
    height: 75.721
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007421179730890562960000015634690826108865966_",
    gradientUnits: "userSpaceOnUse",
    x1: 1932.2413,
    y1: 1314.0259,
    x2: 1933.401,
    y2: 1314.0259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007421179730890562960000015634690826108865966_)"
    },
    d: "M1933.401,1316.836 c-0.535-3.033-0.982-4.906-1.16-5.62C1932.598,1311.929,1933.222,1313.624,1933.401,1316.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M1518.409,414.678h-178.586c-0.548,0-0.996-0.448-0.996-0.996v-15.773 c0-0.548,0.448-0.996,0.996-0.996h178.586c0.548,0,0.996,0.448,0.996,0.996v15.773 C1519.405,414.23,1518.956,414.678,1518.409,414.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M1518.409,457.363h-178.586c-0.548,0-0.996-0.448-0.996-0.996v-15.773 c0-0.548,0.448-0.996,0.996-0.996h178.586c0.548,0,0.996,0.448,0.996,0.996v15.773 C1519.405,456.915,1518.956,457.363,1518.409,457.363z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M1518.409,500.048h-178.586c-0.548,0-0.996-0.448-0.996-0.996v-15.773 c0-0.548,0.448-0.996,0.996-0.996h178.586c0.548,0,0.996,0.448,0.996,0.996v15.773 C1519.405,499.6,1518.956,500.048,1518.409,500.048z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047038256341867610530000006239664571563721398_",
    gradientUnits: "userSpaceOnUse",
    x1: 2586.4597,
    y1: 2006.6045,
    x2: 2631.0938,
    y2: 2006.6045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047038256341867610530000006239664571563721398_)"
    },
    d: "M2586.46,1996.974v15.584 c0,0,6.594,14.83,17.982,11.611c11.389-3.219,26.652-13.369,26.652-13.369v-22.218L2586.46,1996.974z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158004963589853943060000011455181956649918649_",
    gradientUnits: "userSpaceOnUse",
    x1: 2706.9397,
    y1: 2004.1667,
    x2: 2756.9045,
    y2: 2004.1667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158004963589853943060000011455181956649918649_)"
    },
    d: "M2709.937,1988.582l-2.997,26.973 c0,0,8.991,4.196,18.582,4.196c9.591,0,20.013-6.605,25.175-13.147s6.208-18.022,6.208-18.022H2709.937z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083804530315940638070000012005424195237491614_",
    gradientUnits: "userSpaceOnUse",
    x1: 2547.0815,
    y1: 1734.7238,
    x2: 2765.0679,
    y2: 1734.7238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083804530315940638070000012005424195237491614_)"
    },
    d: "M2549.634,1460.523 c0,0-7.311,263.179,2.814,289.872c10.125,26.693,30.374,148.042,29.454,186.7c-0.92,38.658,0.03,54.306,0.03,54.306 s-6.176,16.568,17.607,17.488c23.782,0.921,34.828-15.647,34.828-15.647s8.284-143.439,0-206.029 c-8.284-62.589-12.886-80.998-12.886-80.998s11.966-150.803,26.693-149.882c14.727,0.921,26.692,173.814,26.692,173.814 s23.011,130.553,28.533,181.177c5.523,50.624,0,81.919,0,81.919s0.92,10.125,23.011,8.284 c22.09-1.841,38.658-20.25,38.658-20.25s-8.284-254.812-15.647-278.743s-7.364-23.931-7.364-23.931 s11.966-66.123,11.966-117.667s-0.921-100.411-0.921-100.411H2549.634z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176018140453465840780000004476568518293767079_",
    gradientUnits: "userSpaceOnUse",
    x1: 2335.5259,
    y1: 1275.7634,
    x2: 2856.8616,
    y2: 1275.7634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF871A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176018140453465840780000004476568518293767079_)"
    },
    d: "M2856.687,1345.447 c-4.603,26.949-99.373,43.766-99.373,43.766v71.344h-215.689v-199.482c0,0,0,0.096-0.096,0.192 c-2.877,3.74-55.913,73.847-82.958,71.066c-5.467-0.575-13.522-5.275-23.017-12.659 c-38.554-29.827-100.028-102.042-100.028-102.042s3.26-9.687,12.468-20.62c9.206-10.837,28.579-16.399,28.579-16.399 s75.573,67.9,80.176,69.722c4.604,1.822,75.573-135.513,84.876-144.24c9.207-8.632,68.284-13.139,68.284-13.139 s41.683-1.424,81.365-1.967c33.864-0.463,66.27,9.305,70.068,11.557C2769.685,1107.436,2861.386,1318.594,2856.687,1345.447z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065065147106239608240000001835001939847243656_",
    gradientUnits: "userSpaceOnUse",
    x1: 2503.9487,
    y1: 2031.6293,
    x2: 2636.1101,
    y2: 2031.6293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065065147106239608240000001835001939847243656_)"
    },
    d: "M2585.069,2004.536 c0,0-32.859,16.321-55.876,19.291c-23.017,2.97-25.244,34.896-25.244,34.896s128.449-2.97,129.191-8.91 c0.742-5.94,2.97-40.888,2.97-40.888S2594.169,2026.823,2585.069,2004.536z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110460316681129509950000008805452350973396631_",
    gradientUnits: "userSpaceOnUse",
    x1: 2694.5171,
    y1: 2024.1693,
    x2: 2772.8601,
    y2: 2024.1693
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110460316681129509950000008805452350973396631_)"
    },
    d: "M2704.757,2009.395 c0,0-13.937,32.873-9.292,36.446c4.646,3.573,75.597,2.903,77.286,0c1.689-2.903-16.893-45.778-16.893-45.778 s-7.845,9.619-29.986,10.719C2703.733,2011.881,2708.236,2000.636,2704.757,2009.395z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166674683667895432660000002355384349323679390_",
    gradientUnits: "userSpaceOnUse",
    x1: 2577.946,
    y1: 1033.6663,
    x2: 2699.6128,
    y2: 1033.6663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166674683667895432660000002355384349323679390_)"
    },
    d: "M2578.656,972.157 c0,0-1.47,24.995,0,30.386c1.47,5.391,3.921,8.332,3.921,8.332s-5.228,25.486-4.574,33.817 c0.654,8.332,6.667,32.995,14.998,35.307c8.332,2.312,19.963,4.392,19.963,4.392v17.154c0,0,6.861,11.272,32.347,9.312 c25.485-1.96,37.738-16.565,37.738-16.565v-41.33c0,0,25.485-54.829,13.233-73.453 c-12.252-18.624-40.507-20.584-57.502-23.035C2621.785,954.023,2578.656,972.157,2578.656,972.157z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170967101114860363920000006145447028754622107_",
    gradientUnits: "userSpaceOnUse",
    x1: 2560.9485,
    y1: 971.2825,
    x2: 2728.1428,
    y2: 971.2825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170967101114860363920000006145447028754622107_)"
    },
    d: "M2659.523,983.43 c0,0-3.921,15.193,0,25.976s3.431,23.035,8.822,20.094c5.391-2.941,7.842-35.288,16.664-32.347 c8.822,2.941-0.906,41.772,3.223,43.431c4.129,1.659,40.396-24.809,39.906-65.977c-0.49-41.168-31.367-46.559-31.367-46.559 s-4.465-23.035-38.99-25.976s-77.164,34.307-91.868,48.03c-14.703,13.723,5.881,24.995,27.446,32.837 C2614.924,990.781,2644.82,997.153,2659.523,983.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065781496477518254920000013933660664795528847_",
    gradientUnits: "userSpaceOnUse",
    x1: 2640.9424,
    y1: 1287.2947,
    x2: 2824.7617,
    y2: 1287.2947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.27,
      fill: "url(#SVGID_00000065781496477518254920000013933660664795528847_)"
    },
    d: "M2733.637,1185.372 c0,0,48.846,117.805,55.414,125.194c6.568,7.388,35.711,20.524,35.711,20.524s-43.92-8.209-53.361-4.926 c-9.441,3.284-125.642,63.707-130.344,63.049s136.916-71.416,137.737-77.162 C2779.615,1306.304,2722.554,1189.887,2733.637,1185.372z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170958817506471136390000008436754375494171532_",
    gradientUnits: "userSpaceOnUse",
    x1: 2435.5542,
    y1: 1250.9968,
    x2: 2546.8032,
    y2: 1250.9968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.27,
      fill: "url(#SVGID_00000170958817506471136390000008436754375494171532_)"
    },
    d: "M2546.803,1169.581 l-5.179,91.493c0,0,0,0.096-0.096,0.192c-2.877,3.74-55.913,73.847-82.958,71.066c-5.467-0.575-13.522-5.275-23.017-12.659 c6.617,2.11,14.098,3.452,21.675,2.398c21.291-2.973,66.174-51.405,70.298-68.572 C2531.746,1236.235,2546.803,1169.581,2546.803,1169.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2A9A5"
    },
    d: "M2612.963,1084.391c0,0,19.476-1.037,31.582-10.448c12.106-9.411,12.106-9.411,12.106-9.411 s-4.529,12.83-15.709,19.859s-19.223,23.551-19.223,23.551l-8.756-6.397V1084.391z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176023952173624671040000010268405659281547964_",
    gradientUnits: "userSpaceOnUse",
    x1: -445.4924,
    y1: 1026.0245,
    x2: -64.6764,
    y2: 1026.0245,
    gradientTransform: "matrix(-1 0 0 1 1949.7734 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#595C6C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176023952173624671040000010268405659281547964_)"
    },
    d: "M2077.754,884.31 c-78.298,70.226-84.866,190.603-14.668,268.87c70.197,78.267,190.577,84.785,268.875,14.559 c78.299-70.226,84.865-190.602,14.668-268.869S2156.053,814.084,2077.754,884.31z M2316.138,1150.096 c-68.551,61.483-173.944,55.776-235.402-12.746c-61.458-68.523-55.708-173.914,12.842-235.396 c68.551-61.483,173.944-55.776,235.402,12.746C2390.438,983.222,2384.688,1088.613,2316.138,1150.096z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094613819405114818190000006218438859964428171_",
    gradientUnits: "userSpaceOnUse",
    x1: -362.7831,
    y1: 1191.1785,
    x2: -413.9616,
    y2: 1152.0966,
    gradientTransform: "matrix(-1 0 0 1 1949.7734 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#595C6C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094613819405114818190000006218438859964428171_)"
    },
    d: "M2381.157,1152.062l-70.108,62.88 c-0.429,0.385-1.088,0.349-1.473-0.08l-18.352-20.461l71.661-64.273l18.352,20.461 C2381.622,1151.018,2381.586,1151.678,2381.157,1152.062z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130609067631653556690000001568595670351833246_",
    gradientUnits: "userSpaceOnUse",
    x1: -420.3311,
    y1: 1266.7002,
    x2: -471.245,
    y2: 1227.8204,
    gradientTransform: "matrix(-1 0 0 1 1949.7734 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#595C6C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000130609067631653556690000001568595670351833246_)"
    },
    points: "2470.914,1289.016  2437.468,1319.014 2329.38,1198.501 2362.826,1168.503  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157288667847036626480000013615993649314407815_",
    gradientUnits: "userSpaceOnUse",
    x1: -549.7174,
    y1: 1438.3683,
    x2: -640.3992,
    y2: 1368.2535,
    gradientTransform: "matrix(-1 0 0 1 1949.7734 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#595C6C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157288667847036626480000013615993649314407815_)"
    },
    d: "M2670.037,1487.764l-56.573,50.74 c-0.443,0.397-1.124,0.36-1.521-0.083l-194.267-216.599c-0.397-0.443-0.36-1.124,0.083-1.521l56.573-50.74 c0.443-0.397,1.124-0.36,1.521,0.083l194.267,216.599C2670.516,1486.686,2670.479,1487.367,2670.037,1487.764z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7448 -0.6673 0.6673 0.7448 -121.9791 1733.099)",
    style: {
      opacity: 0.61,
      fill: "#FFFFFF"
    },
    cx: 2204.858,
    cy: 1026.025,
    rx: 166.732,
    ry: 166.664
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001640929766394387310000005036497579063808932_",
    gradientUnits: "userSpaceOnUse",
    x1: 2544.2495,
    y1: 1436.8307,
    x2: 2662.5837,
    y2: 1436.8307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001640929766394387310000005036497579063808932_)"
    },
    d: "M2626.46,1396.511 c0,0-8.067-2.689-18.823-2.689c-10.756,0-18.704,2.689-18.704,2.689l13.236,14.757c0,0-21.421,23.656-38.323,31.723 c-16.902,8.067-26.121,17.532-14.213,17.532c11.908,0,21.127-5.24,21.127-5.24s-15.027,4.809-18.845,10.471 c-3.819,5.662,0.791,6.046,16.54,2.205s-11.147,3.808-6.972,8.463c4.175,4.655,23.871-3.469,23.871-3.469 s-20.249,7.508-17.312,10.782s34.601-5.266,53.808-14.239c19.207-8.973,40.718-41.87,40.718-41.87s0.768-24.2-8.451-30.73 c-9.219-6.53-13.06-7.683-13.06-7.683L2626.46,1396.511z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M1906.502,996.641h-197.567c-0.729,0-1.319,0.591-1.319,1.319v131.668 c0,0.729,0.591,1.319,1.319,1.319h197.567c0.729,0,1.319-0.591,1.319-1.319V997.961 C1907.821,997.232,1907.23,996.641,1906.502,996.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1898.864,1008.395v110.799c0,1.517-1.249,2.855-2.854,2.855h-176.637 c-1.516,0-2.854-1.338-2.854-2.855v-110.799c0-1.516,1.338-2.855,2.854-2.855h176.637 C1897.616,1005.541,1898.864,1006.879,1898.864,1008.395z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127749973627981199550000011410269264860391830_",
    gradientUnits: "userSpaceOnUse",
    x1: 1716.5189,
    y1: 1015.9337,
    x2: 1898.8641,
    y2: 1015.9337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38ACA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F637A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127749973627981199550000011410269264860391830_)"
    },
    d: "M1898.864,1008.395v17.931h-182.345 v-17.931c0-1.516,1.338-2.855,2.854-2.855h176.637C1897.616,1005.541,1898.864,1006.879,1898.864,1008.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1808.487,1040.65h-82.95c-0.16,0-0.291-0.131-0.291-0.291v-4.612 c0-0.16,0.131-0.291,0.291-0.291h82.95c0.16,0,0.291,0.131,0.291,0.291v4.612 C1808.778,1040.519,1808.647,1040.65,1808.487,1040.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1808.487,1053.259h-82.95c-0.16,0-0.291-0.131-0.291-0.291v-4.612 c0-0.16,0.131-0.291,0.291-0.291h82.95c0.16,0,0.291,0.131,0.291,0.291v4.612 C1808.778,1053.128,1808.647,1053.259,1808.487,1053.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1808.487,1065.868h-82.95c-0.16,0-0.291-0.131-0.291-0.291v-4.613 c0-0.16,0.131-0.291,0.291-0.291h82.95c0.16,0,0.291,0.131,0.291,0.291v4.613 C1808.778,1065.737,1808.647,1065.868,1808.487,1065.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1808.487,1078.477h-82.95c-0.16,0-0.291-0.131-0.291-0.291v-4.613 c0-0.16,0.131-0.291,0.291-0.291h82.95c0.16,0,0.291,0.131,0.291,0.291v4.613 C1808.778,1078.346,1808.647,1078.477,1808.487,1078.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1808.487,1091.085h-82.95c-0.16,0-0.291-0.131-0.291-0.291v-4.613 c0-0.16,0.131-0.291,0.291-0.291h82.95c0.16,0,0.291,0.131,0.291,0.291v4.613 C1808.778,1090.954,1808.647,1091.085,1808.487,1091.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D8D8"
    },
    d: "M1808.487,1103.694h-82.95c-0.16,0-0.291-0.131-0.291-0.291v-4.612 c0-0.16,0.131-0.291,0.291-0.291h82.95c0.16,0,0.291,0.131,0.291,0.291v4.612 C1808.778,1103.563,1808.647,1103.694,1808.487,1103.694z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091703604360044015660000012534151911394655112_",
    gradientUnits: "userSpaceOnUse",
    x1: 1985.6329,
    y1: 1990.4741,
    x2: 2028.5787,
    y2: 1990.4741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000091703604360044015660000012534151911394655112_)"
    },
    points: "2028.579,1960.466  2028.579,2005.871 1985.633,2020.482 2007.106,1960.466  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012446388779200602000000000907886002818178735_",
    gradientUnits: "userSpaceOnUse",
    x1: 1890.2106,
    y1: 2020.4822,
    x2: 2038.8468,
    y2: 2020.4822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012446388779200602000000000907886002818178735_)"
    },
    d: "M2033.638,1993.415 c0,0-19.273,16.332-36.753,13.545c-17.48-2.788-93.003-0.995-99.838,2.591s-6.836,35.409-6.836,35.409s143.604,5.827,147.549,0 C2041.706,2039.133,2033.638,1993.415,2033.638,1993.415z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100344119611210551840000005330540268410491529_",
    gradientUnits: "userSpaceOnUse",
    x1: 1852.9698,
    y1: 996.6411,
    x2: 1951.8744,
    y2: 996.6411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100344119611210551840000005330540268410491529_)"
    },
    d: "M1860.78,934.27 c0,0-8.281,25.417-5.846,30.288s3.936,6.977,2.699,10.309c-1.237,3.331-7.493,10.151-3.147,31.098 c4.346,20.947,11.166,37.51,18.473,37.023c7.307-0.487,17.05-3.389,19.973,0.01c2.923,3.4,5.112,16.014,5.112,16.014 l53.832-6.768v-57.116l-41.08-46.157L1860.78,934.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115502912842475455970000003028449625606057403_",
    gradientUnits: "userSpaceOnUse",
    x1: 1838.5603,
    y1: 955.2711,
    x2: 1981.0594,
    y2: 955.2711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115502912842475455970000003028449625606057403_)"
    },
    d: "M1838.56,916.819 c0,0,4.682,20.46,21.732,26.305s24.844,5.358,24.844,11.691s0.487,27.28,4.384,28.254c3.897,0.974,6.26-20.947,18.231-17.05 s-1.255,22.896,0,34.587c1.255,11.691,48.02,18.998,55.814,3.41c7.794-15.589,19.973-43.842,17.05-58.457 c-2.923-14.614-13.172-20.46-13.172-20.46s5.377-21.971-30.184-26.817C1901.699,893.436,1838.56,916.819,1838.56,916.819z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074415008788775225300000008431945198515815078_",
    gradientUnits: "userSpaceOnUse",
    x1: 1944.0516,
    y1: 1386.1245,
    x2: 1793.8817,
    y2: 968.4648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38ACA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F637A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074415008788775225300000008431945198515815078_)"
    },
    d: "M2082.013,1305.198 c-9.991,9.188-36.665,4.996-36.665,4.996v85.82h-217.584v-169.232c0,0-57.63,110.175-80.914,110.175 c-23.373,0-91.173-114.903-91.173-114.903s0.357-24.444,23.73-28.191c23.284-3.747,21.589,0,21.589,0 s33.365,45.498,39.164,43.803c5.799-1.695,49.422-158.348,69.762-161.292c20.34-2.944,54.507-4.103,63.696-10.616 c9.188-6.512,5.798-14.006,5.798-14.006s81.717-8.296,87.605,0c5.799,8.297,7.672,13.025,24.266,14.006 c16.593,0.981,68.246-1.07,75.74,24.533C2074.519,1115.894,2092.094,1296.009,2082.013,1305.198z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127764755363515600440000015435425424441232539_",
    gradientUnits: "userSpaceOnUse",
    x1: 1799.7512,
    y1: 1672.2798,
    x2: 2051.6133,
    y2: 1672.2798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127764755363515600440000015435425424441232539_)"
    },
    d: "M1836.529,1396.055 c0,0-44.247,243.058-35.676,276.225c8.571,33.167,147.469,259.477,147.469,259.477s5.357,7.739,28.927,0 s31.07-25.428,31.07-25.428s-63.496-132.14-84.924-174.151c-21.428-42.011-33.176-42.105-32.562-73.371 c0.614-31.266,55.509-185.281,55.509-185.281c6.514,1.92-10.876,203.951-10.876,213.901c0,9.95,41.784,253.174,41.784,253.174 s4.914,8.914,26.341,7.808c21.428-1.106,27.858-12.891,27.858-12.891s-2.075-75.9,0.068-152.184 c2.143-76.284-15.412-111.09-15.412-111.09s40.112-168.102,35.071-213.67c-4.705-42.524-13.547-62.521-13.547-62.521H1836.529z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179632898670399209870000000630204700147682945_",
    gradientUnits: "userSpaceOnUse",
    x1: 1994.1075,
    y1: 1895.4896,
    x2: 1947.6819,
    y2: 2066.9072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179632898670399209870000000630204700147682945_)"
    },
    d: "M1954.076,1934.683 c0,0,14.27,15.782,34.729,8.16c20.459-7.622,26.878-25.274,29.686-24.471c2.808,0.802,22.866,31.291,19.256,38.111 c-3.61,6.82-72.906,92.496-76.517,93.298c-3.61,0.802-60.977,7.221-64.588-12.436c-3.61-19.657,38.111-10.43,43.326-28.483 C1945.184,1990.809,1954.076,1934.683,1954.076,1934.683z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106831177775825282160000000179455000331807618_",
    gradientUnits: "userSpaceOnUse",
    x1: 1954.0756,
    y1: 1929.0249,
    x2: 2017.1902,
    y2: 1929.0249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106831177775825282160000000179455000331807618_)"
    },
    d: "M2003.718,1909.512l13.472,17.514 c0,0-3.518,13.76-28.703,20.183s-34.412-12.526-34.412-12.526L2003.718,1909.512z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160902224285333401700000011028620623950073510_",
    gradientUnits: "userSpaceOnUse",
    x1: 1827.7638,
    y1: 1280.6205,
    x2: 1852.2039,
    y2: 1280.6205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.27,
      fill: "url(#SVGID_00000160902224285333401700000011028620623950073510_)"
    },
    d: "M1852.029,1396.014 h-24.265v-169.232c0,0,14.809-27.923,17.842-45.586c1.338-7.405,1.516-12.489,1.338-15.969 c1.784,9.01,4.371,28.19,4.817,61.555c0.803,49.869-0.714,124.627,0,137.652 C1852.565,1377.547,1852.029,1396.014,1852.029,1396.014z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133525860188930426370000000205169775264076693_",
    gradientUnits: "userSpaceOnUse",
    x1: 2041.2014,
    y1: 1242.9169,
    x2: 2062.8787,
    y2: 1242.9169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.27,
      fill: "url(#SVGID_00000133525860188930426370000000205169775264076693_)"
    },
    d: "M2045.348,1310.194 l-4.146-135.301l21.677,135.301C2062.879,1310.194,2050.328,1311.875,2045.348,1310.194z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089560878014992443520000014145766910060212146_",
    gradientUnits: "userSpaceOnUse",
    x1: 1657.4948,
    y1: 1150.7495,
    x2: 1740.4709,
    y2: 1150.7495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089560878014992443520000014145766910060212146_)"
    },
    d: "M1694.63,1192.206 c0,0,0.378-28.785,9.165-38.336s27.544-13.754,32.11-21.776c4.566-8.023,4.566-8.023,4.566-8.023s-12.985,1.528-22.92,4.203 c-9.935,2.674-9.935,2.674-9.935,2.674v-40.654c0,0-38.208,15.057-45.274,44.092c-7.066,29.036-4.322,76.819-4.322,76.819 S1668.273,1195.012,1694.63,1192.206z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F7F6"
    },
    d: "M860.515,926.772v388.161c0,12.766-10.356,23.122-23.121,23.122H507.307 c-12.765,0-23.001-10.356-23.001-23.122V926.772c0-12.765,10.236-23.122,23.001-23.122h330.087 C850.159,903.65,860.515,914.007,860.515,926.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M766.445,1232.724H519.727c-0.247,0-0.45-0.202-0.45-0.45v-9.931c0-0.247,0.202-0.45,0.45-0.45 h246.718c0.247,0,0.45,0.202,0.45,0.45v9.931C766.895,1232.521,766.692,1232.724,766.445,1232.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M841.563,1261.711H519.727c-0.247,0-0.45-0.202-0.45-0.45v-9.931c0-0.247,0.202-0.45,0.45-0.45 h321.836c0.247,0,0.45,0.202,0.45,0.45v9.931C842.012,1261.509,841.81,1261.711,841.563,1261.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4C4C4"
    },
    d: "M731.107,1286.792h-211.38c-0.247,0-0.45-0.202-0.45-0.45v-9.931c0-0.247,0.202-0.45,0.45-0.45 h211.38c0.247,0,0.45,0.202,0.45,0.45v9.931C731.556,1286.59,731.354,1286.792,731.107,1286.792z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170975046832815502520000012943140674245317802_",
    gradientUnits: "userSpaceOnUse",
    x1: 484.3064,
    y1: 925.0256,
    x2: 860.5153,
    y2: 925.0256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38ACA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F637A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170975046832815502520000012943140674245317802_)"
    },
    d: "M860.515,926.772v19.629H484.306 v-19.629c0-12.765,10.236-23.122,23.001-23.122h330.087C850.159,903.65,860.515,914.007,860.515,926.772z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129177018297786436010000013395846239722479027_",
    gradientUnits: "userSpaceOnUse",
    x1: 672.3647,
    y1: 1046.0635,
    x2: 729.0482,
    y2: 1046.0635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129177018297786436010000013395846239722479027_)"
    },
    d: "M682.252,989.823 c0,0,25.172-6.298,37.807,12.655c12.635,18.953,11.319,40.354,0,62.162s4.212,35.11,4.212,35.11 s-24.009,12.494-43.592-9.354C661.095,1068.549,682.252,989.823,682.252,989.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB7B1"
    },
    d: "M654.711,1071.831v14.979c0,0,3.201,4.892,18.216,4.719 c15.015-0.173,17.091-3.979,17.091-3.979v-19.203L654.711,1071.831z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175311379990331753290000006252513319327549571_",
    gradientUnits: "userSpaceOnUse",
    x1: 1360.8038,
    y1: 1044.1547,
    x2: 1424.9272,
    y2: 1044.1547,
    gradientTransform: "matrix(-1 0 0 1 2065.7925 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175311379990331753290000006252513319327549571_)"
    },
    d: "M704.241,1007.674 c0,0,8.312,67.877-30.475,72.962h-1.676c-38.787-5.086-30.476-72.963-30.476-72.963L704.241,1007.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M741.362,1111.397c-16.682,19.496-41.391,31.799-68.916,31.799 c-27.628,0-52.337-12.302-69.019-31.799c2.085-4.483,4.066-8.757,5.943-12.094c2.19-3.649,4.171-6.464,6.047-7.819 c10.321-7.611,37.325-8.133,39.306-8.133c0.104,0,0.104,0,0.104,0s-1.043,2.92,6.255,5.839 c3.441,1.355,19.288,1.355,22.624,0c5.838-2.293,6.36-4.692,6.36-5.525c0-0.209,0-0.313,0-0.313s28.671,0.209,39.41,8.133 c1.877,1.355,3.857,4.17,5.943,7.819C737.4,1102.64,739.381,1106.914,741.362,1111.397z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103968997237896355740000007920638456052612739_",
    gradientUnits: "userSpaceOnUse",
    x1: 631.2975,
    y1: 1019.0137,
    x2: 717.7045,
    y2: 1019.0137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103968997237896355740000007920638456052612739_)"
    },
    d: "M704.988,991.966 c-16.055-8.951-27.306-12.075-41.178-9.479c-13.872,2.597-22.945,14.508-22.945,14.508s-8.662,5.294-9.456,16.412 c-0.399,5.587,0.338,11.311,1.177,17.401l0.001-0.002c0,0,6.234,18.329,13.276,25.615c-0.888-3.479-0.62-6.927,1.382-10.966 c2.988-6.029,2.63-27.764,2.63-27.764s3.952,13.186,23.051,17.95c19.099,4.765,25.981,2.647,26.246,6.353 c0.144,2.014,0.65,6.913,0.229,12.069l0.024-0.029c0,0,3.142-1.339,9.723-9.881c6.559-8.515,8.543-24.738,8.556-24.842 C715.871,1007.003,712.107,995.935,704.988,991.966z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161622302026970516100000004955605128660883858_",
    gradientUnits: "userSpaceOnUse",
    x1: 581.8461,
    y1: 1052.6995,
    x2: 762.9435,
    y2: 1052.6995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF871A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161622302026970516100000004955605128660883858_)"
    },
    d: "M672.446,962.203 c-50.044,0-90.6,40.452-90.6,90.496c0,22.416,8.132,42.955,21.581,58.698c16.682,19.496,41.391,31.799,69.019,31.799 c27.525,0,52.234-12.302,68.916-31.799c13.449-15.743,21.582-36.282,21.582-58.698 C762.943,1002.655,722.387,962.203,672.446,962.203z M735.419,1099.303c-14.179,19.288-37.116,31.799-62.973,31.799 c-25.856,0-48.793-12.511-63.076-31.799c-9.696-13.032-15.43-29.192-15.43-46.604c0-43.371,35.135-78.402,78.506-78.402 c43.268,0,78.403,35.031,78.403,78.402C750.849,1070.111,745.115,1086.271,735.419,1099.303z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150061797359122452460000012048805121823858561_",
    gradientUnits: "userSpaceOnUse",
    x1: 553.6079,
    y1: 1932.5708,
    x2: 723.6428,
    y2: 1932.5708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150061797359122452460000012048805121823858561_)"
    },
    d: "M553.608,1754.944 c0,0,55.19,269.844,53.055,283.365c-2.135,13.52-7.827,15.655,16.367,34.156c24.194,18.501,45.542,38.426,59.062,37.714 c13.52-0.712,44.83-20.636,41.272-22.059c-3.558-1.423-61.196-27.752-67.601-46.965 c-6.404-19.213-17.078-267.557-17.078-267.557L553.608,1754.944z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026154938193560836020000007109472270768752530_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.292,
    y1: 1903.4749,
    x2: 456.8188,
    y2: 1903.4749,
    gradientTransform: "matrix(0.9989 -0.046 0.046 0.9989 -51.732 48.3347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026154938193560836020000007109472270768752530_)"
    },
    d: "M405.337,1776.15 c0,0-7.825,46.662-11.726,116.651c-3.901,69.989-3.032,119.813-7.517,130.704c-4.485,10.891-3.536,31.506,7.454,38.123 c10.99,6.617,68.749,38.863,67.833,18.96c-0.916-19.904-29.915-46.35-25.472-73.623 c4.443-27.274,49.925-215.288,49.925-215.288L405.337,1776.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030475154612428165710000003547624185570224297_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.2297,
    y1: 1249.3203,
    x2: 842.9808,
    y2: 1249.3203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF871A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030475154612428165710000003547624185570224297_)"
    },
    d: "M487.464,1061.287 c0,0,39.244-6.623,46.116,0c6.872,6.624,12.76,20.606,12.76,20.606s65.499-5.761,79.482,25.758 c13.983,31.519,93.47,161.172,93.47,161.172l96.276-42.754c0,0,13.309-1.145,21.805,17.125 c8.496,18.27,4.817,25.629,4.817,25.629s-117.751,70.65-130.262,70.65c-12.511,0-86.105-73.594-86.105-73.594v174.418H406.51 v-78.01c0,0-46.364,4.597-50.044-35.234c-3.68-39.832-6.95-165.442,6.46-183.591 C376.336,1125.314,487.464,1061.287,487.464,1061.287z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042715620097232421360000016739174587205552021_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.0929,
    y1: 996.2714,
    x2: 558.7116,
    y2: 996.2714
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042715620097232421360000016739174587205552021_)"
    },
    d: "M533.73,940.432 c0,0,15.193,15.653,18.416,25.782c3.223,10.128,8.287,41.467,5.985,52.961c-2.302,11.494-35.91,21.622-35.91,21.622v23.94 h-41.435c0,0-58.469-116.478-16.574-131.671C506.107,917.873,533.73,940.432,533.73,940.432z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118368299112798208440000008107170341224797576_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.2909,
    y1: 1019.2941,
    x2: 553.6078,
    y2: 1019.2941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118368299112798208440000008107170341224797576_)"
    },
    d: "M553.527,921.095 c1.842,28.544-28.084,55.707-42.356,54.786c-14.272-0.921-12.891-17.495-22.099-17.495c-9.208,0-15.653,19.402-2.302,31.799 c13.351,12.398,37.575,40.942,21.32,64.422c-16.256,23.48,17.176,42.816,0,65.835 c-17.176,23.019-83.012,57.548-145.164,23.019c-62.152-34.529-18.415-85.172,10.128-106.81 c28.544-21.638-16.114-75.043,24.861-115.557c40.975-40.514,98.523-47.42,125.226-34.989 C549.844,898.536,553.527,921.095,553.527,921.095z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039126415574308456510000017692088522320950700_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.1652,
    y1: 1630.2806,
    x2: 648.6803,
    y2: 1630.2806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039126415574308456510000017692088522320950700_)"
    },
    d: "M406.51,1440.297 c0,0-19.301,24.369-4.063,82.015s-14.171,247.803-14.171,247.803s-17.996,36.772,90.846,46.93s166.525-6.979,166.525-6.979 s2.545-78.602,3.026-157.547c0.481-78.945-27.092-212.223-27.092-212.223H406.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124149116150507409980000001043040468578002346_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.6646,
    y1: 2089.5989,
    x2: 761.1572,
    y2: 2089.5989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124149116150507409980000001043040468578002346_)"
    },
    d: "M605.028,2046.187 c0,0-14.432,10.384-16.165,34.068c-1.733,23.684-5.199,50.834-5.199,50.834s13.286,6.354,16.174-4.043 c2.888-10.398,7.51-49.679,14.442-46.213c6.932,3.466,36.97,41.014,53.145,42.747c16.175,1.733,90.693-1.733,93.581-16.752 c2.888-15.019-36.698-17.498-50.785-24.938c0,0-14.341,19.161-37.811,11.074S635.635,2049.667,605.028,2046.187z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020397234703792018890000000218615983356946582_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.8492,
    y1: 2045.6913,
    x2: 447.5884,
    y2: 2045.6913,
    gradientTransform: "matrix(0.9989 -0.046 0.046 0.9989 -51.732 48.3347)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020397234703792018890000000218615983356946582_)"
    },
    d: "M386.094,2023.505 c0,0-12.297,26.757-10.173,53.486c2.125,26.729,2.302,50.934,2.302,50.934s3.036,1.718,12.651-0.583 c9.615-2.3,13.061-5.141,13.061-5.141s1.774-53.667,4.902-52.06s16.421,29.616,26.319,30.949 c9.898,1.333,52.249,8.325,55.284-3.439c3.035-11.765-34.938-34.862-34.938-34.862s8.335,17.945-13.52,10.584 C420.128,2066.014,417.112,2034.339,386.094,2023.505z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142169495941990585440000011446828812702514614_",
    gradientUnits: "userSpaceOnUse",
    x1: 824.7612,
    y1: 1212.5817,
    x2: 884.3629,
    y2: 1212.5817
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFB4B4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142169495941990585440000011446828812702514614_)"
    },
    d: "M824.761,1228.615 c0,0,0.607-27.747,6.609-40.792c6.002-13.044,21.197-23.315,21.197-23.315s4.892,2.118,0,12.445 c-4.892,10.327-0.544,22.828,2.174,16.306s21.197-32.611,25.545-26.089c4.348,6.522,7.609,35.776-3.261,49.955 c-10.87,14.18-34.045,43.53-34.045,43.53S838.806,1237.883,824.761,1228.615z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001645729758363147200000001318440001218025345_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.2941,
    y1: 1282.0294,
    x2: 406.51,
    y2: 1282.0294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.27,
      fill: "url(#SVGID_00000001645729758363147200000001318440001218025345_)"
    },
    d: "M406.51,1362.287 l-10.141-161.489l-15.075,158.223C381.294,1359.022,401.081,1365.705,406.51,1362.287z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102518767351481943720000000911994200478103445_",
    gradientUnits: "userSpaceOnUse",
    x1: 596.1485,
    y1: 1311.6904,
    x2: 625.8209,
    y2: 1311.6904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3149"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.27,
      fill: "url(#SVGID_00000102518767351481943720000000911994200478103445_)"
    },
    d: "M625.821,1265.879 v174.418h-29.672c0,0,16.263-144.735,6.564-185.924c-9.699-41.19,0.133-71.29,0.133-71.29S604.93,1251.262,625.821,1265.879z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165197638471600479300000001437312536690572684_",
    gradientUnits: "userSpaceOnUse",
    x1: 2200.7146,
    y1: 1110.6525,
    x2: 2200.7146,
    y2: 1002.4496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#38ACA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F637A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000165197638471600479300000001437312536690572684_)"
    },
    cx: 2200.715,
    cy: 1025.779,
    r: 99.242
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2139.221,1021.816l26.214,46.81c1.477,2.638,5.035,3.13,7.076,0.899 c9.434-10.32,33.71-35.799,55.123-49.2c27.265-17.064,48.149-17.644,48.149-17.644s-30.746-10.948-62.071,5.258 c-31.325,16.206-41.188,28.611-41.188,28.611l-13.517-25.815c-1.799-3.435-6.106-4.666-9.448-2.7l-7.857,4.622 C2138.52,1014.526,2137.418,1018.596,2139.221,1021.816z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceDepolyment);
export default __webpack_public_path__ + "static/media/resource-depolyment.eb5d9971f47c3d3471712540d0126250.svg";
export { ForwardRef as ReactComponent };